import { useNavigate } from "react-router-dom";
import SectionHeader from "@/components/base/SectionHeader";

const themes = [
  {
    icon: "ri-server-line",
    title: "Enterprise Infrastructure",
    scope: "LAN/WAN engineering, server and collaboration systems, virtualization, and network operations for mission-critical environments.",
    tags: ["Infrastructure", "Network Engineering"],
  },
  {
    icon: "ri-folder-3-line",
    title: "Database & Data Platform",
    scope: "Oracle and SQL Server database engineering and administration, schema management, and data integrity.",
    tags: ["Database", "SQL Server"],
  },
  {
    icon: "ri-layout-grid-line",
    title: "Application & Platform Support",
    scope: "Enterprise software and platform support, WebSphere, application maintenance, and integration services.",
    tags: ["Application", "Platform"],
  },
  {
    icon: "ri-window-line",
    title: "Microsoft Power Platform & SharePoint",
    scope: "Power Apps, Power Automate, Power BI, SharePoint workflows, integration, and user enablement.",
    tags: ["Power Platform", "SharePoint"],
  },
  {
    icon: "ri-global-line",
    title: "Web & Digital Solutions",
    scope: "Website development, CMS solutions, web portals, content migration, and accessibility-aware development.",
    tags: ["Web", "CMS"],
  },
  {
    icon: "ri-team-line",
    title: "Technical Staffing & Delivery",
    scope: "Qualified engineers, administrators, developers, analysts, and technical SMEs for defined programs.",
    tags: ["Staffing", "SME"],
  },
];

export default function PastPerformanceSection() {
  const navigate = useNavigate();

  return (
    <section className="section-padding bg-white">
      <div className="container-page">
        <SectionHeader
          title="Delivery Experience"
          subtitle="Our Track Record"
          description="Technology capabilities and delivery experience Mitaja brings to federal, state/local, and commercial programs."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {themes.map((theme) => (
            <div
              key={theme.title}
              className="card-base p-6 hover:border-primary-300 transition-all duration-300"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                <i className={`${theme.icon} text-primary-600 text-lg`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-2">
                {theme.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {theme.scope}
              </p>
              <div className="flex flex-wrap gap-2">
                {theme.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs px-2.5 py-1 rounded-full bg-secondary-50 text-secondary-700 font-medium"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => { navigate("/experience"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
            className="btn-primary"
          >
            View Past Performance
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>
    </section>
  );
}